module.exports = __webpack_public_path__ + "img/charging-hub-in-progress.9583a95a.png";